import type { TOC } from '@ember/component/template-only';

import PrismAlert from './alert.gts';

interface PrismWormholeSignature {
  Args: {};
}

const PrismWormhole = <template>
  <div id="prism-wormhole"></div>
  <PrismAlert />
</template> satisfies TOC<PrismWormholeSignature>;

export default PrismWormhole;
